import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config =  {
    name: 'inventory-buffer',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' }
    ],
    endpoints: {
        inventoryBuffers: '/inventory-buffer',
        inventoryBuffer: '/inventory-buffer/[id]'
    },
    defaults: {
        inventoryBuffer: {
            productId: null,
            product: {},
            cardId: null,
            card: {},
            quantity: 0,
            comment: "",
        }
    },
    validations: {
        paymentType: yup.object().shape({
            quantity: yup.number().required("Cantitatea este obligatorie"),
        })
    }
}

const Config ={
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
